import _ from "lodash";

import { api, fetchRespJson, postData } from "apis/base";

export default {
  getUnitIdsExchange,
};

async function getUnitIdsExchange({ unitIds, extGamUnitIds }) {
  const apiUrl = `${api}/tools/unit-ids-exchange`;
  let updateParams = {
    unitIds,
    extGamUnitIds,
  };
  return await postData(apiUrl, updateParams);
}
